import React, { useState } from 'react';

const ScannedResults = ({ items = [], onDelete }) => {
  const [prefixType, setPrefixType] = useState('none');
  const [customPrefix, setCustomPrefix] = useState('');
  
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        alert('Copied to clipboard!');
      })
      .catch(err => {
        console.error('Could not copy text: ', err);
      });
  };
  
  const getFormattedText = (text) => {
    if (prefixType === 'none') {
      return text;
    } else if (prefixType === 'slash') {
      return `/${text}`;
    } else if (prefixType === 'hash') {
      return `#${text}`;
    } else if (prefixType === 'id') {
      return `ID: ${text}`;
    } else if (prefixType === 'custom') {
      return `${customPrefix}${text}`;
    }
    return text;
  };
  
  const exportAsCSV = () => {
    if (items.length === 0) return;
    
    // Create CSV content
    const headers = ['Name', 'URL', 'Slug'];
    const csvRows = [headers.join(',')];
    
    items.forEach(item => {
      const formattedText = getFormattedText(item.text);
      const row = [
        `"Add a Name (optional)"`,
        `"Enter or paste URL"`,
        `"${formattedText}"`
      ];
      csvRows.push(row.join(','));
    });
    
    const csvContent = csvRows.join('\n');
    
    // Create a blob and download link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    
    link.setAttribute('href', url);
    link.setAttribute('download', `id-scan-results-${new Date().toISOString().slice(0, 10)}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (items.length === 0) {
    return (
      <div className="mt-6 max-w-4xl mx-auto sm:px-0m">
        <h2 className="mt-2 text-m text-gray-700 font-semibold mb-1">Scanned Items</h2>
        <p className="text-center text-gray-500 italic py-8">No items scanned yet</p>
      </div>
    );
  }

  return (
    <div className="mt-6 max-w-4xl mx-auto sm:px-0m">
              <h2 className="mt-2 text-m text-gray-700 font-semibold mb-1">Scanned Items</h2>

      <div className="flex justify-between items-center mb-4">        
        <div className="flex items-center space-x-2">
          <select 
            value={prefixType}
            onChange={(e) => setPrefixType(e.target.value)}
            className="text-sm border border-gray-300 rounded px-2 py-1"
          >
            <option value="none">No Prefix</option>
            <option value="slash">/ (Slash)</option>
            <option value="hash"># (Hash)</option>
            <option value="id">ID:</option>
            <option value="custom">Custom</option>
          </select>
          
          {prefixType === 'custom' && (
            <input
              type="text"
              value={customPrefix}
              onChange={(e) => setCustomPrefix(e.target.value)}
              placeholder="Custom prefix"
              className="text-sm border border-gray-300 rounded px-2 py-1 w-24"
            />
          )}
          
          <button
            onClick={() => {
              const formattedItems = items.map(item => getFormattedText(item.text)).join('\n');
              copyToClipboard(formattedItems);
            }}
            className="text-sm bg-blue-100 hover:bg-blue-200 text-blue-700 px-3 py-1 rounded transition-colors"
          >
            Copy All
          </button>
          
          <button
            onClick={exportAsCSV}
            className="text-sm bg-green-100 hover:bg-green-200 text-green-700 px-3 py-1 rounded transition-colors"
          >
            Export CSV
          </button>
        </div>
      </div>
      
      <div className="space-y-4">
        {items.map((item) => (
          <div key={item.id} className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
            <div className="flex justify-between items-center mb-2">
              <div className="font-semibold text-google-blue">{item.description}</div>
              <div className="flex items-center space-x-2">
                <div className="text-xs text-gray-500">{item.timestamp}</div>
                <button
                  onClick={() => onDelete(item.id)}
                  className="text-red-500 hover:text-red-700"
                  title="Delete"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="bg-gray-50 p-3 rounded-md mb-3 font-mono text-sm break-all">
              {getFormattedText(item.text)}
            </div>
            
            <div className="flex justify-end">
              <button 
                className="text-google-blue border border-google-blue px-3 py-1 rounded-md text-sm hover:bg-google-blue hover:text-white transition-colors duration-200"
                onClick={() => copyToClipboard(getFormattedText(item.text))}
              >
                Copy
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScannedResults;